import React from "react";

import { ContentOptions } from "../../constants/content-options";
import "./index.scss";

export const ContentItem = ({
  index,
  post,
}: {
  index: number;
  post: Partial<Queries.MarkdownRemarkEdge>;
}) => {
  const { frontmatter, fields, excerpt, timeToRead } = post.node!;

  const {
    showTitle,
    showSubtitle,
    showCategory,
    showIcon,
    showDate,
    showContent,
    showTimeToRead,
  } = ContentOptions;

  // const category = Category.All;

  return (
    <div className="contentItem" role="presentation">
      <div className="emptyBorder" />
      <a
        // href={`${fields.slug}?${qs.stringify({ category })}#blog`}
        // href={
        //   category
        //     ? `${fields!.slug}?${qs.stringify({ category })}#blog`
        //     : `${fields!.slug}`
        // }

        // href={
        //   window.location.search
        //     ? `${fields!.slug}${window.location.search}`
        //     : `${fields!.slug}`
        // }

        href={`${fields!.slug}`}
        className="contentItemInner"
      >
        {showCategory && (
          <p className="itemCategory">{frontmatter!.category}</p>
        )}
        <div className="itemHeader">
          {showIcon && frontmatter!.emoji && (
            <p role="img" aria-label="itemIcon" className="itemIcon">
              {frontmatter!.emoji}
            </p>
          )}
          {showTitle && <p className="itemTitle">{frontmatter!.title}</p>}
        </div>
        {showSubtitle && (
          <p className="itemSubTitle">{frontmatter!.subtitle}</p>
        )}
        {showDate && <p className="itemDate">{frontmatter!.date}</p>}
        {showContent && (
          <p
            className="itemText"
            dangerouslySetInnerHTML={{ __html: excerpt! }}
          />
        )}
        {showTimeToRead && (
          <p className="itemTimeToRead">{timeToRead} min read</p>
        )}
      </a>
    </div>
  );
};
